var styles = {
  "Code": "Polaris-InlineCode__Code"
};

export { styles as default };
